import { API } from "@infra/api";
import { makeLabelsUseCases } from "@app/labels";
import type { ILabels } from "@ports/labels/ILabels";
import type { IPdfOpener } from "@ports/labels/IPdfOpener";

const labelsApi: ILabels = {
	getPdfBlob: (lab, robot, tracking) => API.Labels.getPdfBlob(lab, robot, tracking),
};

const browserPdfOpener: IPdfOpener = {
	open: async (blob) => {
		const url = URL.createObjectURL(blob);
		window.open(url, "_blank", "noopener,noreferrer");
		// Revoke later so the new tab has time to load it.
		window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
	},
};

export const labelsUseCases = makeLabelsUseCases({ labelsApi, pdfOpener: browserPdfOpener });
